import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { parseDuplicateParameters } from '../../utility/uiUtils';
import { API_ABSENCE_REQUESTS } from '../../constants/apiRoutes';
import { ABSENCE_REQUESTS_DEFAULT_PARAMS } from '../../constants/pages';

// ------------------------------------
// Constants
// ------------------------------------

const SET_ALL_ABSENCE_REQUESTS = 'SET_ALL_ABSENCE_REQUESTS';
const LOAD_MORE_ABSENCE_REQUESTS = 'LOAD_MORE_ABSENCE_REQUESTS';

const initialState = {};

// ------------------------------------
// Actions
// ------------------------------------

const setAllAbsenceRequests = createAction(SET_ALL_ABSENCE_REQUESTS);
const loadMoreAbsenceRequests = createAction(LOAD_MORE_ABSENCE_REQUESTS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_ALL_ABSENCE_REQUESTS]: (state, { payload }) => {
    return { ...payload };
  },
  [LOAD_MORE_ABSENCE_REQUESTS]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      results: state.results
        ? [...state.results, ...payload.results]
        : [...payload.results],
    };
  },
};

export const getAllAbsenceRequests = (
  dispatch,
  isLoadMore = false,
  params = {}
) => {
  return http
    .get(API_ABSENCE_REQUESTS, {
      params: { ...ABSENCE_REQUESTS_DEFAULT_PARAMS, ...params },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(
        isLoadMore ? loadMoreAbsenceRequests(data) : setAllAbsenceRequests(data)
      );
    });
};

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearAllAbsenceRequests = () =>
  setAllAbsenceRequests(initialState);

export default handleActions(reducers, initialState);
